import { useMatchScreen } from '../context/MatchScreenContext'
import { useAdvisorOrderRandomization } from './useAdvisorOrderRandomization'
import { AdvisorData, GeneralAdvisorData } from '../utils/types'
import fallbackRoboAdvisors from '../utils/appconfigs/FallbackRoboAdvisors'

const hasAdvisorMatchId = (data: GeneralAdvisorData | undefined): data is AdvisorData[] => {
  return Array.isArray(data) && data.length > 0 && 'advisorMatchId' in data[0]
}

export const useAdvisorsData = (): GeneralAdvisorData | undefined => {
  const { state } = useMatchScreen()
  const sessionUUID = state?.sessionUUID
  const isPreview = state?.isPreview
  const originalAdvisorsData = state?.matches

  const advisorsForRandomization = hasAdvisorMatchId(originalAdvisorsData) ? originalAdvisorsData : undefined
  const randomizedAdvisors = useAdvisorOrderRandomization(advisorsForRandomization)

  // Use fallback RoboAdvisors if:
  // 1. User is anonymous (no sessionUUID) — except on admin previews, which
  //    intentionally carry an empty session UUID but supply real matches
  // 2. No matches returned (empty array or no data)
  // 3. API call failed (advisorsData is null/undefined)
  const shouldUseFallback = (!sessionUUID && !isPreview) || !originalAdvisorsData || originalAdvisorsData.length === 0

  if (shouldUseFallback) {
    return fallbackRoboAdvisors.roboAdvisors as unknown as GeneralAdvisorData
  }

  return randomizedAdvisors ?? originalAdvisorsData
}
